import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { debounce } from 'lodash';
import {
  Editor,
  EditorState,
  Modifier,
  RichUtils,
  convertToRaw,
  getDefaultKeyBinding,
} from "draft-js";
import { draftToMarkdown } from "markdown-draft-js";
import SendInbox from "../../../../assets/customSVG/inbox/SendInbox";
import { ICONS } from "../../../../assets/icons";
import Loader from "../../../../components/commonComponents/Loader/Index";

// assets
import Delete from "../../../../assets/customSVG/Delete";
import DocSvg from "../../../../assets/customSVG/DocSvg";
import ImageSvg from "../../../../assets/customSVG/ImageSvg";
import VideoSvg from "../../../../assets/customSVG/VideoSvg";
import "../../../../components/commonComponents/editor/editor.css";
import "../../styles/message_input.css";

// utils
import { Drawer, Modal, Popover } from "antd";

// hooks
import useToggle from "../../../../hooks/useToggle";

// redux
import { cn } from "../../../../helper/cn";
import { updateToggleToast } from "../../../../reduxToolkit/appSlice";
import { markMessagesAsRead } from "../../api/Api";

import {
  useAspDispatch,
  useAspSelector,
} from "../../../../test/jest-redux-hooks";

// icons
import InboxNoteIcon from "../../../../assets/customSVG/inbox/InboxNoteIcon";

// components
import LightningIcon from "../../../../assets/customSVG/LightningIcon";
import InlineStyleControls from "../../../../components/commonComponents/editor/InlineStyleControls";
import Header from "../../../../components/commonComponents/modals/Header";
import TemplateListContainer from "../../../../components/commonComponents/templates/TemplateListContainer";
import NoteEditor from "./NoteEditor";
import QuickReplyPanel from "./QuickReplyPanel";

// helper
import { uploadFile } from "../../../../helper/uploadFile";
import { replaceFormating } from "../../helper/index";

// contents
import {
  FEATURE_FLAG_SEND_ATTACHMENTS,
  FEATURE_FLAG_SEND_DOCUMENT,
  FEATURE_FLAG_SEND_IMAGE,
  FEATURE_FLAG_SEND_VIDEO,
  FEATURE_FLAG_TEMPLATE_CHANGE_MEDIA,
  FEATURE_FLAG_TEMPLATE_CHANGE_VARIABLE,
} from "../../constants/FeatureFlag";
import { INLINE_STYLES, mediaIcons } from "../../constants/index";
import { MESSAGE_TYPES } from "../../constants/index";

// API
import {
  createNote,
  inboxQuickReplies,
  sendTemplateMessage,
  sendTextMessage,
  updateNote,
} from "../../api/Api";

import { useNote } from "../../providers/NoteContext";

let fileType = ".jpg, .png";

const MessageInput = React.memo(
  ({
    activeTabItem,
    selectedPhoneNumber,
    selectedPerson,
    conversationType,
    isChatResolved,
    chatToggle,
    selectedData,
    selectedFile,
    setSelectedFile,
    isUploading,
    setIsUploading,
    handleChat,
    showList,
    setShowList,
    openTemplateList,
    setOpenTemplateList,
    assignGetData,
    setMembersTrue,
    getConversations,
    selectedMessage,
    setSelectedMessage,
    item,
    getNotes,
    setSelectedData,
    getAttachments,
    scrollingBottom
  }) => {
    const editorRef = useRef(null);
    const textareaRef = useRef(null);
    const fileInputRef1 = useRef();
    const fileInputRef2 = useRef();
    const fileInputRef3 = useRef();

    const prevCountRef = useRef(0);

    const dispatch = useAspDispatch();

    const { currentBrand, toggleToast } = useAspSelector((state) => state.app);

    // styles
    const uploadContainer =
      "h-[3vw] flex items-center gap-[0.3vw] bg-[var(--primary)] px-[0.5vw] py-[0.1.5vw] rounded-[0.5vw] cursor-pointer";
    const error = "text-[var(--fontRed)] font-md weight-400 my-[0.5vw]";
    const countryCode =
    selectedPerson?.phone_country_code?.replace("+", "") || "";

    // hooks
    const [showQuickRepliesManager, setShowQuickRepliesManager] =
      useToggle(false);
    const [quickReplies, setQuickReplies] = useState([]);
    const [quickRepliesLoading, setQuickRepliesLoading] = useState(false);
    const [showToolbar, setShowToolbar] = useToggle(false);

    // editor
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [showEmojiPickerCaption, setShowEmojiPickerCaption] =
      useToggle(false);
    const [showEmojiPicker, setShowEmojiPicker] = useToggle(false);
    const [mediaCaption, setMediaCaption] = useState("");
    const [msg, setMsg] = useState("");
    const [updateFormat, setUpdateFormat] = useState("text");
    const [paste, setPaste] = useState(false);

    // Media files
    const [errorMsg, setErrorMsg] = useToggle(false);
    const [fileOpen, setFileOpen] = useState(false);
    const [updatedData, setUpdatedData] = useState(null);
    const [openAttachment, setOpenAttachment] = useToggle(false);
    const [selectedFileType, setSelectedFileType] = useState(null);
    const [selectedFileURL, setSelectedFileURL] = useState(null);
    const [isClearingMedia, setIsClearingMedia] = useState(false);
    const [multipMedia, setMultiMedia] = useState([]);

    // template
    const [isSending, setIsSending] = useToggle(false);
    const [isMsgSending, setIsMsgSending] = useToggle(false);

    // notes
    const { noteContent, setNoteContent } = useNote();
    const [isNoteLoading, setIsNoteLoading] = useState(false);

    let page = 1;

    const multipleImages = () => {
      setMultiMedia([...multipMedia]);
    };

    const onCloseShowList = (value) => {
      setShowList(value ?? !showList);
      setSelectedMessage(null);
    };

    const reply_message_image_template =
      selectedData?.message &&
      selectedData?.message?.template?.map((item) => item);
    const previewContent =
      reply_message_image_template &&
      reply_message_image_template?.map((item) => item);

    useEffect(() => {
      clearMedia();
      setEditorState(EditorState.createEmpty());
      setNoteContent({ content: "" });
    }, [selectedPerson]);

    // remove selected media file
    const clearMedia = () => {
      setMsg("");
      setSelectedFile(null);
      setSelectedFileType(null);
      setSelectedFileURL(null);
      setSelectedData(null)
      setIsClearingMedia(true);
    };

    // popover contents
    const atteachmentsContent = (
      <div className="w-44 h-fit p-[0.5vw] flex flex-col gap-1 justify-between">
        {FEATURE_FLAG_SEND_IMAGE && (
          <div className={cn("w-full max-h-12")}>
            <div
              className="w-full flex items-center relative gap-[0.6vw] px-[0.6vw] py-[0.5vw] rounded-[0.37vw] hover:bg-[var(--BG-25)] cursor-pointer"
              onClick={() => {
                fileInputRef1.current.value = null;
                fileInputRef1.current.click();
                setOpenAttachment(false);
                setUpdateFormat("image");
              }}
            >
              <ImageSvg color="var(--contentText)" width={22} height={22} />
              <p>Photos</p>
            </div>
          </div>
        )}
        {FEATURE_FLAG_SEND_VIDEO && (
          <div className={cn("w-full max-h-12")}>
            <div
              className="w-full flex items-center relative gap-[0.6vw] px-[0.6vw] py-[0.5vw] rounded-[0.37vw] hover:bg-[var(--BG-25)] cursor-pointer"
              onClick={() => {
                fileInputRef2.current.value = null;
                fileInputRef2.current.click();
                setOpenAttachment(false);
                setUpdateFormat("video");
              }}
            >
              <VideoSvg color="var(--contentText)" width={22} height={22} />
              <p>video</p>
            </div>
          </div>
        )}
        {FEATURE_FLAG_SEND_DOCUMENT && (
          <div className={cn("w-full max-h-12")}>
            <div
              className="w-full flex items-center relative gap-[0.6vw] px-[0.6vw] py-[0.5vw] rounded-[0.37vw] hover:bg-[var(--BG-25)] cursor-pointer"
              onClick={() => {
                fileInputRef3.current.value = null;
                fileInputRef3.current.click();
                setOpenAttachment(false);
                setUpdateFormat("document");
              }}
            >
              <DocSvg color="var(--contentText)" width={22} height={22} />
              <p>Doc</p>
            </div>
          </div>
        )}
        <input
          type="file"
          accept={".jpg, .png"}
          onChange={(e) => {
            handleUploadFiles(e, "image");
          }}
          id="uploadImg"
          ref={fileInputRef1}
          hidden
        />
        <input
          type="file"
          accept={".mp4"}
          onChange={(e) => {
            handleUploadFiles(e, "video");
          }}
          id="uploadImg"
          ref={fileInputRef2}
          hidden
        />
        <input
          type="file"
          accept={".pdf"}
          onChange={(e) => {
            handleUploadFiles(e, "document");
          }}
          id="uploadImg"
          ref={fileInputRef3}
          hidden
        />
      </div>
    );

    const sendMessage = async (sendFrom, sendTo, brandId, msg) => {
      setIsMsgSending(true);
      setMembersTrue(false);
      try {
        const res = await sendTextMessage({
          sendFrom: sendFrom,
          sendTo: selectedPerson?.phone_country_code + sendTo,
          brandId: brandId,
          msg: msg,
          contact_conversation_id: selectedPerson?.id,
          replay_to: selectedData?.meta_message_id,
        });
        setMsg("");
        if (res?.status === 200) {
          setIsMsgSending(false);
          setEditorState(EditorState?.createEmpty());
          setMediaCaption("");
          clearMedia();
          setMembersTrue(true);

          let dynamicLimit = 100;
          const initialCount = await getConversations(
            "select",
            currentBrand?.brand_id,
            dynamicLimit,
            1,
            selectedPerson?.id,
            true
          );

          if (initialCount !== undefined && initialCount !== 0) {
            await getConversations(
              "select",
              currentBrand?.brand_id,
              initialCount,
              1,
              selectedPerson?.id,
              true
            );
          }

          scrollingBottom();
          setUpdatedData(null);

          if (["image", "video", "document"].includes(msg?.type)) {
            getAttachments(attachmentFilter);
          }
        }

        if (res?.status !== 200) {
          setIsMsgSending(false);
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content: "message send failed",
                status: "Success",
                duration: "",
              },
            ])
          );
        }
      } catch (e) {
        console.warn(e);
      }
    };

    const sendTemplate = async ({
      sendFrom,
      sendTo,
      metaTemplateId,
      brandId,
      subcategory_type,
      category,
      mediaUrl,
      variables,
      payment_details,
    }) => {
      setIsSending(true);
      setMembersTrue(false);

      try {
        const res = await sendTemplateMessage({
          sendFrom: sendFrom,
          sendTo: [countryCode + " " + sendTo],
          metaTemplateId: metaTemplateId,
          brandId: brandId,
          subcategory_type: subcategory_type,
          category: category,
          contact_conversation_id: selectedPerson?.id,
          variables: [{ ...variables, ...mediaUrl }],
          payment_details: payment_details,
        });

        if (res?.status === 200) {
          setIsSending(false);
          setMembersTrue(true);
          setOpenTemplateList(false);
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content: "Template send successfully",
                status: "Success",
                duration: "",
              },
            ])
          );

          let dynamicLimit = 100;
          const initialCount = await getConversations(
            "select",
            currentBrand?.brand_id,
            dynamicLimit,
            1,
            selectedPerson?.id,
            true
          );

          if (initialCount !== undefined && initialCount !== 0) {
            await getConversations(
              "select",
              currentBrand?.brand_id,
              initialCount,
              1,
              selectedPerson?.id,
              true
            );
          }
          scrollingBottom();
        }

        if (res?.status !== 200) {
          setIsSending(false);
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content: "Template send failed",
                status: "Failed",
                duration: "",
              },
            ])
          );
        }
      } catch (e) {
        console.warn(e);
      }
    };

    const allowToSendMessage = useCallback(() => {
      const isEditorValid =
        editorState?.getCurrentContent()?.getPlainText()?.trim()?.length > 0;

      const isFileValid = selectedFile !== null || selectedFileURL !== null;

      const isMediaValid =
        (updatedData?.type === "image" &&
          updatedData?.image?.link?.length > 0) ||
        (updatedData?.type === "video" &&
          updatedData?.video?.link?.length > 0) ||
        (updatedData?.type === "document" &&
          updatedData?.document?.link?.length > 0);

      return (
        (isMediaValid && isFileValid) ||
        isEditorValid ||
        (isEditorValid && isFileValid)
      );
    }, [updatedData, selectedFile, editorState]);

    const handleSendMessage = useCallback(() => {
      if (!isMsgSending && allowToSendMessage()) {
        sendMessage(
          !activeTabItem?.send_from_phone_number_id
            ? selectedPhoneNumber?.send_from_phone_number_id
            : activeTabItem?.send_from_phone_number_id,
          selectedPerson?.to_number,
          currentBrand?.brand_id,
          updatedData,
          selectedPerson?.id,
          true
        );
      }
    }, [
      isMsgSending,
      allowToSendMessage,
      sendMessage,
      activeTabItem,
      selectedPhoneNumber,
      selectedPerson,
      currentBrand,
      updatedData,
    ]);

    // quick replies
    const fetchQuickReplies = async () => {
      setQuickRepliesLoading(true);
      const payLoad = {
        brand_id: currentBrand?.brand_id,
      };
      const response = await inboxQuickReplies(payLoad);
      if (response && response?.data?.quick_reply_groups?.length >= 0) {
        setQuickReplies(response?.data?.quick_reply_groups);
        setQuickRepliesLoading(false);
      }
    };

    const handleSelectedMessage = (message) => {
      const contentState = editorState.getCurrentContent();
      const selection = editorState.getSelection();
      const contentStateWithText = Modifier.insertText(
        contentState,
        selection,
        message
      );
      const newEditorState = EditorState.push(
        editorState,
        contentStateWithText,
        "insert-characters"
      );
      setEditorState(newEditorState);
      setShowQuickRepliesManager(false);
      onEditorChange(newEditorState);
    };

    // template
    const handleCancel = () => {
      setOpenTemplateList(false);
    };

    // Function to strip only actual link entities
    function removeLinksFromRawContent(rawContent) {
      const { entityMap, blocks } = rawContent;

      // Remove all LINK entities from entityMap
      const linkEntityKeys = Object.entries(entityMap)
        .filter(([_, entity]) => entity.type === 'LINK')
        .map(([key]) => key);

      // Remove links from inlineStyleRanges and entityRanges
      const newBlocks = blocks.map(block => {
        if (!block.entityRanges) return block;

        const newEntityRanges = block.entityRanges.filter(
          range => !linkEntityKeys.includes(range.key.toString())
        );

        return {
          ...block,
          entityRanges: newEntityRanges,
        };
      });

      return {
        blocks: newBlocks,
        entityMap: {}, // Clear all entities
      };
    }

    // Debounced typing indicator
    const debouncedTyping = useMemo(
      () =>
        debounce(() => {
          try {
            const payLoad = {
              brand_id: currentBrand?.brand_id,
              contact_conversation_id: selectedPerson?.id,
              is_typing: true
            };
            markMessagesAsRead(payLoad);
          } catch (error) {
            console.error('Error sending typing status:', error);
          }
        }, 1000), // Wait for 1 second of inactivity
      [currentBrand, selectedPerson]
    );

    // Cleanup debounce on unmount
    useEffect(() => {
      return () => {
        debouncedTyping.cancel();
      };
    }, [debouncedTyping]);

    // editor
    const onEditorChange = (newState) => {
      setEditorState(newState);
      setShowEmojiPicker(false);
      setShowEmojiPickerCaption(false);

      const content = newState?.getCurrentContent();
      const rawObject = convertToRaw(content);
      
      // Only trigger typing indicator if there's actually content
      if (content.hasText()) {
        debouncedTyping();
      }
      
      // Remove real link entities only
      const rawWithoutLinks = removeLinksFromRawContent(rawObject);

      // Convert to Markdown (will have no [text](url))
      const markdownString = draftToMarkdown(rawWithoutLinks);

      // if (isClearingMedia) {
      //   setIsClearingMedia(false);
      //   return; // Skip further execution
      // }

      setMsg(markdownString);

      if (!paste) {
        if (
          ["image", "video", "document"]?.includes(updateFormat) &&
          (selectedFile !== null || selectedFileURL !== null)
        ) {
          setUpdatedData({
            ...updatedData,
            [updatedData?.type]: {
              ...updatedData[updatedData?.type],
              caption: markdownString || msg,
            },
          });
        } else {
          setUpdatedData({
            type: "text",
            text: {
              body: markdownString,
            },
          });
        }
      }

      // setEditorState(markdownString);
    };

    const handleCaptionChange = (e) => {
      const captions = e.target.value;

      setMediaCaption(captions);

      if (
        ["image", "video", "document"]?.includes(updateFormat) &&
        (selectedFile !== null || selectedFileURL !== null)
      ) {
        setUpdatedData({
          ...updatedData,
          [updatedData?.type]: {
            ...updatedData[updatedData?.type],
            caption: captions,
          },
        });
      }
    };

    const handleBeforeInput = (val) => {
      const contentState = editorState.getCurrentContent();
      const selection = editorState.getSelection();
      const blockKey = selection.getStartKey();
      const block = contentState.getBlockForKey(blockKey);
      const blockText = block.getText();
      const anchorOffset = selection.getAnchorOffset();

      const MAX_CHAR_LIMIT = 1024;
      const textLength = contentState.getPlainText().length;

      // Block further input if character limit is reached
      if (val && textLength >= MAX_CHAR_LIMIT) {
        return "handled";
      }

      // Only act when user types a space
      if (val !== " ") {
        return "not-handled";
      }

      // Simulate what the text would be if this space were added
      const textBeforeInput = blockText.slice(0, anchorOffset);
      const simulatedText = textBeforeInput + val;

      // Match patterns at the beginning of the line
      const listTypeMap = {
        "- ": "unordered-list-item",
        "* ": "unordered-list-item",
        "1. ": "ordered-list-item",
      };

      const matchedEntry = Object.entries(listTypeMap).find(([pattern]) =>
        simulatedText.startsWith(pattern)
      );

      if (!matchedEntry) {
        return "not-handled";
      }

      const [triggerPattern, listType] = matchedEntry;

      // Toggle the block type (UL or OL)
      let newEditorState = RichUtils.toggleBlockType(editorState, listType);
      let newContent = newEditorState.getCurrentContent();
      let newBlock = newContent.getBlockForKey(blockKey);

      // If successfully changed, remove the trigger text
      if (newBlock.getType() === listType) {
        const newText = blockText
          .replace(triggerPattern.trim(), "")
          .trimStart();

        const updatedBlock = newBlock.set("text", newText);
        const updatedContent = newContent.set(
          "blockMap",
          newContent.getBlockMap().set(blockKey, updatedBlock)
        );

        const finalEditorState = EditorState.push(
          newEditorState,
          updatedContent,
          "change-block-type"
        );

        setEditorState(finalEditorState);
        return "handled";
      }

      return "not-handled";
    };

    const onClose = () => {
      setFileOpen(false);
      setMediaCaption("");
      setSelectedFile(null);
      setSelectedFileType(null);
      setSelectedFileURL(null);
      setIsClearingMedia(true);
    };

    const handleEmojiClickCaption = (emoji) => {
      setMediaCaption((prevMediaCaption) => prevMediaCaption + emoji.native);
      setShowEmojiPickerCaption(false);
    };

    const mapKeyToEditorCommand = (e) => {
      if (e.key === "b" && e.metaKey) return "bold";

      if (e.key === "i" && e.metaKey) return "italic";

      if (e.key === "s" && e.metaKey) return "strikethrough";

      if (e.key === "Enter" && !e.shiftKey) {
        return "send-message";
      }

      return getDefaultKeyBinding(e);
    };

    const handleKeyCommand = (command, editorState, containerRef) => {
      const newState = RichUtils.handleKeyCommand(editorState, command);

      if (newState) {
        setEditorState(newState);
        return "handled";
      }

      if (command === "send-message") {
        if (!isMsgSending && allowToSendMessage()) {
          sendMessage(
            !activeTabItem?.send_from_phone_number_id
              ? selectedPhoneNumber?.send_from_phone_number_id
              : activeTabItem?.send_from_phone_number_id,
            selectedPerson?.to_number,
            currentBrand?.brand_id,
            updatedData,
            selectedPerson?.id
          );
          return "handled";
        }
      }
      return "not-handled";
    };

    const handleToolbarClick = (style) => {
      const blockStyles = ["unordered-list-item", "ordered-list-item"]; // Add more if needed
      const isBlock = blockStyles.includes(style);

      const newState = isBlock
        ? RichUtils.toggleBlockType(editorState, style)
        : RichUtils.toggleInlineStyle(editorState, style);

      setEditorState(newState);
    };

    const handleFilePaste = useCallback(
      (text, fileType) => {
        setPaste(true);
        setSelectedFileURL(text);
        setSelectedFileType({ label: fileType.toUpperCase() });
        setFileOpen(true);
        setUpdateFormat(fileType);

        setUpdatedData({
          ...updatedData,
          type: fileType,
          [fileType]: {
            link: text,
            caption: updatedData?.[fileType]?.caption || msg,
            // caption: updatedData?.[fileType]?.caption || msg,
          },
        });

        return "handled";
      },
      [fileType]
    );

    const handlePastedText = (text) => {
      const textLength = editorState.getCurrentContent().getPlainText().length;

      if (text && textLength >= 1024) {
        return "handled";
      }

      if (text) {
        if (/\.(jpeg|jpg|gif|png)$/.test(text)) {
          return handleFilePaste(text, "image");
        }

        if (/\.(mp4|webm|ogg)$/.test(text)) {
          return handleFilePaste(text, "video");
        }

        if (/\.(pdf|doc|docx|ppt|pptx|xls|xlsx|txt)$/.test(text)) {
          return handleFilePaste(text, "document");
        }
      }

      return "not-handled";
    };

    // media files
    // handle upload media files

    const handleUploadFiles = async (e, format) => {
      setFileOpen(true);
      setIsUploading(true);
      setErrorMsg(false);
      if (e?.target?.files?.[0]) {
        const selectedFile = e?.target?.files?.[0];
        const responseFile = await uploadFile(e?.target?.files?.[0], {
          path: "inbox",
          brand_id: currentBrand?.brand_id,
          phone_number: selectedPerson?.phone_country_code + selectedPerson?.to_number,
        });

        let fileTypes = {
          label: format
            ? format?.toUpperCase()
            : selectedFile?.type?.split("/")?.[0]?.toUpperCase(),
        };

        setUpdatedData({
          ...updatedData,
          type: format,
          [format]: {
            link: responseFile,
            caption: updatedData?.[format]?.caption || msg,
          },
        });

        setSelectedFileType(fileTypes);

        if (responseFile) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setSelectedFileURL(responseFile);
            setIsUploading(false);
          };
          setSelectedFile(selectedFile);
          reader.readAsDataURL(selectedFile);
          if (fileTypes?.label === "IMAGE")
            selectedFile.size < 5 * 1024 * 1024
              ? setErrorMsg(false)
              : setErrorMsg(true);

          if (fileTypes?.label === "VIDEO")
            selectedFile.size < 16 * 1024 * 1024
              ? setErrorMsg(false)
              : setErrorMsg(true);

          if (fileTypes?.label === "DOCUMENT")
            selectedFile.size < 100 * 1024 * 1024
              ? setErrorMsg(false)
              : setErrorMsg(true);
        }
      } else {
        setIsUploading(false);
      }
    };

    // notes
    const noteCreate = () => {
      setIsNoteLoading(true);

      const payLoad = {
        brand_id: currentBrand?.brand_id,
        contact_conversation_id: selectedPerson?.id,
        content: noteContent.content,
      };

      const showPayLoad = {
        brand_id: currentBrand?.brand_id,
        contact_conversation_id: selectedPerson?.id,
        limit: 100,
        page: 1,
      };

      let dynamicLimit = 100;

      createNote(payLoad)
        .then((res) => {
          if (res?.status === 200) {
            // showSuccessToast(notification, "Note created");
            setNoteContent(({ id, ...rest }) => rest);
            setNoteContent({ content: "" });
            getNotes(currentBrand?.brand_id, selectedPerson?.id);

            getConversations(
              "select",
              currentBrand?.brand_id,
              dynamicLimit,
              page,
              selectedPerson?.id,
              true
            );
          } else {
            showErrorToast(
              notification,
              "Failed to create note: " + res?.response?.data?.error
            );
            setIsNoteLoading(false); // Also handle failure
          }

          // ✅ Move it here
          setIsNoteLoading(false);
        })
        .catch((error) => {
          console.error("Failed to create note:", error);
          setIsNoteLoading(false); // Also handle failure
        });
    };

    const noteUpdate = () => {
      setIsNoteLoading(true);

      const payLoad = {
        brand_id: currentBrand?.brand_id,
        contact_conversation_id: selectedPerson?.id,
        content: noteContent.content,
        tag_id: noteContent.id,
      };

      // const showPayLoad = {
      //   brand_id: currentBrand?.brand_id,
      //   contact_conversation_id: selectedPerson?.id,
      //   limit: 100,
      //   page: 1,
      // };

      let dynamicLimit = 100;

      updateNote(payLoad)
        .then((res) => {
          if (res?.status === 200) {
            setNoteContent(({ id, ...rest }) => rest);
            setNoteContent({ content: "" });

            getNotes(currentBrand?.brand_id, selectedPerson?.id);
            getConversations(
              "select",
              currentBrand?.brand_id,
              dynamicLimit,
              page,
              selectedPerson?.id,
              true
            );
          }
        })
        .catch((err) => {
          console.error("Error in updateNote:", err);
        })
        .finally(() => {
          setIsNoteLoading(false); // ✅ always runs
        });
    };

    const handleNoteEmojiClick = (emoji) => {
      setTimeout(() => {
        const textarea =
          textareaRef.current || document.querySelector("textarea");

        if (!textarea) {
          console.warn("Textarea not found");
          return;
        }

        const emojiChar = emoji.native || emoji.emoji || emoji.colons || "";
        const { selectionStart, selectionEnd } = textarea;
        const value = noteContent.content;

        const newText = value
          ? value?.slice(0, selectionStart) +
            emojiChar +
            value?.slice(selectionEnd)
          : emojiChar;

        setNoteContent((prev) => ({
          ...prev,
          content: newText,
        }));

        const newPos = selectionStart + emojiChar.length;
        textarea.focus();
        textarea.setSelectionRange(newPos, newPos);
        setShowEmojiPickerCaption(false);
      }, 0);
    };

    // emoji
    const handleEmojiClick = (emoji) => {
      const contentState = editorState?.getCurrentContent();
      const selection = editorState?.getSelection();

      if (selection.isCollapsed()) {
        const contentStateWithEmoji = contentState.createEntity(
          "emoji",
          "IMMUTABLE",
          {
            emoji: emoji.native,
          }
        );
        const entityKey = contentStateWithEmoji?.getLastCreatedEntityKey();

        const contentStateWithEntity = Modifier.insertText(
          contentStateWithEmoji,
          selection,
          emoji.native,
          null,
          entityKey
        );

        const newEditorStateWithEntity = EditorState.push(
          editorState,
          contentStateWithEntity,
          "insert-fragment"
        );

        setEditorState(newEditorStateWithEntity);
        // setBodyObj({ ...bodyObj, text: newEditorStateWithEntity });
        setShowEmojiPicker(false);
        onEditorChange(newEditorStateWithEntity);
      }
    };

    const reply_message_template =
      selectedData?.message &&
      selectedData?.message?.template?.map((item) => item?.text);

    return (
      <>
        <div
          className={`w-full h-auto flex px-[1vw] pt-[1vw] pb-[5px] mx-[12px]}`}
        >
          {conversationType?.includes("closed") ? (
            chatToggle ? (
              <div className="w-full px-[1vw] py-[1vh] bg-[var(--BG-25)] text-[var(--white)] flex flex-col  rounded-[0.5vw]">
                <div className="w-full mx-auto  mt-10">
                  <p className="text-[1rem] text-[#4C515B] font-[500]">
                    Your open conversation has timed out.
                  </p>
                  <p className="text-[0.875rem] font-[300] text-[#8796AF]">
                    start a conversation using templates by clicking the button
                    below.
                  </p>
                </div>

                <div className="flex items-center gap-[0.5vw]">
                  <div
                    className="w-auto flex-row align-center justify-start p-5 pointer"
                    onClick={() => {
                      setOpenTemplateList(true);
                    }}
                  >
                    <span className="inbox-button px-2.5 py-1.5 b-radius-6">
                      Choose Template
                    </span>
                  </div>
                  <div className="w-auto flex items-center gap-[0.5vw] border-[#ececeb] pr-[1vw]">
                    <button
                      className="flex items-center gap-[0.3vw] border text-[rgba(135, 150, 175, 1)] var(--font-600) rounded-[0.3vw] p-1 hover:bg-[#ececeb] transition-colors duration-200"
                      onClick={handleChat}
                    >
                      <InboxNoteIcon fill="#000000" />
                      <span className="text-gray-700 font-medium text-[14px]">
                        Add a Note
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <NoteEditor
                noteContent={noteContent}
                setNoteContent={setNoteContent}
                handleChat={handleChat}
                showEmojiPickerCaption={showEmojiPickerCaption}
                setShowEmojiPickerCaption={setShowEmojiPickerCaption}
                data={data}
                assignGetData={assignGetData}
                textareaRef={textareaRef}
                handleNoteEmojiClick={handleNoteEmojiClick}
                noteUpdate={noteUpdate}
                noteCreate={noteCreate}
                isNoteLoading={isNoteLoading}
              />
            )
          ) : (
            <>
              {isChatResolved ? (
                <div
                  style={{ width: "100%" }}
                  className={`textEditorContainer flex-column space-between p-10 bg-[white] mt-10 ${
                    selectedFile || isUploading ? "!h-[15vh]" : "!h-[13vh]"
                  }`}
                >
                  <div className="flex-column">
                    <span className="ml-5 text-[1.1rem] text-[#4C515B] font-[500]">
                      That chat is resolved
                    </span>
                    <span className="ml-5 text-[0.875rem] text-[#8796AF] font-[300]">
                      You can reopen the chat to follow up with the customer.
                    </span>
                  </div>
                  <div
                    className="w-auto flex-row align-center justify-start p-5 mb-5 pointer"
                    onClick={() => {
                      onResolvedClick(item);
                    }}
                  >
                    <span className="inbox-button px-2.5 py-1.5 b-radius-6">
                      Reopen Chat
                    </span>
                  </div>
                </div>
              ) : (
                <>
                  {chatToggle ? (
                    <div
                      className={`flex flex-col textEditorContainer overflow-hidden bg-white p-[10px] gap-y-[18px]`}
                      style={{
                        width: "100%",
                        minHeight: "15vh",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {selectedData && (
                        <div className="b-radius-6 relative w-full pt-2 px-2">
                          <div className="w-full flex-row align-center bg-[var(--channelButton)] inbox12px-400 text-[var(--font-600)] b-radius-6 mb-10">
                            <div className="h-[6vh] bg-[#6564CA] w-1" />
                            <div className="flex flex-1 items-center justify-between ml-10 py-1.5">
                              {Object.values(MESSAGE_TYPES).includes(selectedData?.message?.type) && (
                                <>
                                  {mediaIcons[selectedData?.message?.type] && (
                                    <img
                                      src={mediaIcons[selectedData?.message?.type]}
                                      alt={selectedData?.message?.type}
                                      className="media-icon flex-shrink-0"
                                    />
                                  )}
                                  <div className="w-full flex justify-between items-center min-w-0">
                                    {(() => {
                                      const messageType = selectedData?.message?.type;
                                      
                                      switch (messageType) {
                                        case "image":
                                          return (
                                            <>
                                              <p className="truncate">{selectedData?.message?.image?.caption || "Image"}</p>
                                              <img
                                                src={selectedData?.message?.image?.link}
                                                className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10 flex-shrink-0"
                                                alt="Preview"
                                              />
                                            </>
                                          );
                                          
                                        case "video":
                                          return (
                                            <>
                                              <p className="truncate">{selectedData?.message?.video?.caption || "Video"}</p>
                                              <video className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10 flex-shrink-0">
                                                <source src={selectedData?.message?.video?.link} type="video/mp4" />
                                              </video>
                                            </>
                                          );
                                          
                                        case "document":
                                          return (
                                            <>
                                              <p className="truncate">{selectedData?.message?.document?.caption || "Document"}</p>
                                              <iframe
                                                className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10 flex-shrink-0"
                                                src={selectedData?.message?.document?.link}
                                                title="Document preview"
                                              />
                                            </>
                                          );
                                          
                                        case "audio":
                                          return (
                                            <>
                                              <p className="truncate">{selectedData?.message?.audio?.caption || "Audio"}</p>
                                              <audio className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10 flex-shrink-0">
                                                <source src={selectedData?.message?.audio?.link} type="audio/mp3" />
                                              </audio>
                                            </>
                                          );
                                          
                                        case "text":
                                          return (
                                            <div className="w-full break-words new-body-text rounded-[0.6vw] rounded-tl-none">
                                              <div
                                                className="overflow-hidden text-ellipsis"
                                                style={{
                                                  display: '-webkit-box',
                                                  WebkitLineClamp: 2,
                                                  WebkitBoxOrient: 'vertical',
                                                  overflow: 'hidden'
                                                }}
                                                dangerouslySetInnerHTML={{
                                                  __html: replaceFormating(selectedData?.message?.text?.body),
                                                }}
                                              />
                                            </div>
                                          );
                                          
                                        case "button":
                                          return (
                                            <div 
                                              className="new-body-text rounded-[0.6vw] rounded-tl-none overflow-hidden text-ellipsis w-full"
                                              style={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden'
                                              }}
                                            >
                                              {selectedData?.message?.button?.text}
                                            </div>
                                          );
                                          
                                        case "template":
                                          return (
                                            <>
                                              <div 
                                                className="max-w-[60ch] ml-10 overflow-hidden text-ellipsis"
                                                style={{
                                                  display: '-webkit-box',
                                                  WebkitLineClamp: 2,
                                                  WebkitBoxOrient: 'vertical',
                                                  overflow: 'hidden'
                                                }}
                                              >
                                                {reply_message_template}
                                              </div>
                                              <div className="flex-shrink-0">
                                                {previewContent?.length > 0 && (
                                                  <>
                                                    {previewContent[0]?.format === "IMAGE" && (
                                                      <img
                                                        src={previewContent[0]?.example?.header_handle?.[0]}
                                                        className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10"
                                                        alt="Template preview"
                                                      />
                                                    )}
                                                    {previewContent[0]?.format === "VIDEO" && (
                                                      <video className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10">
                                                        <source
                                                          src={previewContent[0]?.example?.header_handle?.[0]}
                                                          type="video/mp4"
                                                        />
                                                      </video>
                                                    )}
                                                    {previewContent[0]?.format === "DOCUMENT" && (
                                                      <iframe
                                                        className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10"
                                                        src={previewContent[0]?.example?.header_handle?.[0]}
                                                        title="Template document preview"
                                                      />
                                                    )}
                                                    {previewContent[0]?.format === "AUDIO" && (
                                                      <audio className="w-[40px] h-[40px] object-cover rounded-lg ml-10 mr-10">
                                                        <source
                                                          src={previewContent[0]?.example?.header_handle?.[0]}
                                                          type="audio/mp3"
                                                        />
                                                      </audio>
                                                    )}
                                                  </>
                                                )}
                                              </div>
                                            </>
                                          );
                                          
                                        case 'interactive':
                                          return (
                                            <div className="w-full break-words new-body-text rounded-[0.6vw] rounded-tl-none">
                                              <div
                                                className="overflow-hidden text-ellipsis"
                                                style={{
                                                  display: '-webkit-box',
                                                  WebkitLineClamp: 2,
                                                  WebkitBoxOrient: 'vertical',
                                                  overflow: 'hidden'
                                                }}
                                                dangerouslySetInnerHTML={{
                                                  __html: replaceFormating(selectedData?.message?.interactive?.body?.text),
                                                }}
                                              />
                                            </div>
                                          );

                                        case 'contacts':
                                          return (
                                            <div className="w-full break-words new-body-text rounded-[0.6vw] rounded-tl-none">
                                              <div
                                                className="overflow-hidden text-ellipsis"
                                                style={{
                                                  display: '-webkit-box',
                                                  WebkitLineClamp: 2,
                                                  WebkitBoxOrient: 'vertical',
                                                  overflow: 'hidden'
                                                }}
                                                dangerouslySetInnerHTML={{
                                                  __html: replaceFormating(selectedData?.message?.contacts?.[0]?.name?.formatted_name),
                                                }}
                                              />
                                            </div>
                                          );

                                        case 'location':
                                          return (
                                            <div className="w-full break-words new-body-text rounded-[0.6vw] rounded-tl-none">
                                              <div
                                                className="overflow-hidden text-ellipsis"
                                                style={{
                                                  display: '-webkit-box',
                                                  WebkitLineClamp: 2,
                                                  WebkitBoxOrient: 'vertical',
                                                  overflow: 'hidden'
                                                }}
                                                dangerouslySetInnerHTML={{
                                                  __html: replaceFormating(selectedData?.message?.location?.name),
                                                }}
                                              />
                                            </div>
                                          )
                                        default:
                                          return null;
                                      }
                                    })()}
                                  </div>
                                  <img
                                    src={ICONS?.popupX}
                                    alt="close"
                                    className="w-[1.8vw] h-[1.8vw] pointer flex-shrink-0"
                                    onClick={() => setSelectedData(null)}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      <div
                        // ref={editorRef}
                        className={`w-full text-[0.95rem] max-h-[10vh] text-[var(--textBlack)] overflow-y-scroll listScroll break-words whitespace-pre-wrap`}
                        onDoubleClick={() => setShowToolbar(!showToolbar)}
                      >
                        <Editor
                          className=""
                          ref={editorRef}
                          editorState={editorState}
                          handleKeyCommand={(command, state) =>
                            handleKeyCommand(command, state, editorRef)
                          }
                          keyBindingFn={mapKeyToEditorCommand}
                          onChange={onEditorChange}
                          placeholder={
                            editorState.getCurrentContent().hasText() ||
                            editorState
                              .getCurrentContent()
                              .getBlockMap()
                              .first()
                              .getType() !== "unstyled"
                              ? ""
                              : "Write your message or type / to pick a quick Reply messages"
                          }
                          handleBeforeInput={handleBeforeInput}
                          handlePastedText={handlePastedText}
                          editorClassName="break-words whitespace-pre-wrap"
                          readOnly={isMsgSending || item?.agent_engagement_status}
                        />
                      </div>
                      {(selectedFile || isUploading || selectedFileURL) && (
                        <div className="">
                          <div className="flex items-center gap-[0.8vw] px-[1vw]">
                            {isUploading ? (
                              <div className="w-full h-[6.5vh] flex items-center">
                                <Loader
                                  Width={30}
                                  Height={30}
                                  loaderBg="white"
                                />
                              </div>
                            ) : (
                              (selectedFile || selectedFileURL) && (
                                <div className="w-24 h-[3vh] flex items-center gap-[1vw]">
                                  <div className="">
                                    <div className="mb-10 relative">
                                      {["IMAGE", "VIDEO", "DOCUMENT"]?.includes(
                                        selectedFileType?.label
                                      ) &&
                                        selectedFileURL && (
                                          <div className="border border-red-600">
                                            <Drawer
                                              rootClassName="message-input-drawer"
                                              title="Send Media"
                                              placement="bottom"
                                              onClose={onClose}
                                              open={fileOpen}
                                              onOpenChange={(open) =>
                                                setFileOpen(open)
                                              }
                                            >
                                              <div className="w-100 bg-white rounded-2xl">
                                                {/* <Header
                                          title="Send Media"
                                          handleCancel={handleCancel}
                                          className="new-header"
                                        /> */}
                                                <div className="">
                                                  {selectedFileType?.label ===
                                                    "IMAGE" &&
                                                    selectedFileURL && (
                                                      <img
                                                        src={selectedFileURL}
                                                        alt="preview images"
                                                        className="w-100 !h-64 rounded-2xl"
                                                      />
                                                    )}
                                                  {selectedFileType?.label ===
                                                    "VIDEO" &&
                                                    selectedFileURL && (
                                                      <div>
                                                        <video
                                                          className="w-100 !h-64 rounded-2xl"
                                                          controls
                                                        >
                                                          <source
                                                            src={
                                                              selectedFileURL
                                                            }
                                                            type="video/mp4"
                                                          />
                                                        </video>
                                                      </div>
                                                    )}
                                                  {selectedFileType?.label ===
                                                    "DOCUMENT" &&
                                                    selectedFileURL && (
                                                      <iframe
                                                        title="cover"
                                                        className="w-100"
                                                        src={selectedFileURL}
                                                      ></iframe>
                                                    )}
                                                  <div
                                                    className="absolute top-[7vw] p-5 b-radius-6 bg-white right-[3vw] cursor-pointer"
                                                    onClick={() => {
                                                      clearMedia();
                                                    }}
                                                  >
                                                    <Delete
                                                      width="20"
                                                      height="20"
                                                      className={`stroke-[red] group-hover:stroke-red-500 pointer`}
                                                      color=""
                                                    />
                                                  </div>
                                                  <div
                                                    key={item.id}
                                                    className="w-100 flex-row align-center border border-[var(--border-input)] rounded-md p-10"
                                                  >
                                                    <input
                                                      className={`w-100 ${
                                                        isMsgSending
                                                          ? "bg-white opacity-100 cursor-not-allowed"
                                                          : "bg-white"
                                                      } text-black`}
                                                      autoComplete="off"
                                                      maxLength={256}
                                                      type="text"
                                                      onChange={
                                                        handleCaptionChange
                                                      }
                                                      placeholder="Caption (optional)"
                                                      value={mediaCaption}
                                                      disabled={isMsgSending}
                                                    />
                                                    <Popover
                                                      trigger={["click"]}
                                                      open={
                                                        showEmojiPickerCaption
                                                      }
                                                      onOpenChange={(open) =>
                                                        setShowEmojiPickerCaption(
                                                          open
                                                        )
                                                      }
                                                      arrow={false}
                                                      content={
                                                        <Picker
                                                          data={data}
                                                          onEmojiSelect={
                                                            handleEmojiClickCaption
                                                          }
                                                          searchPosition="none"
                                                          previewPosition="none"
                                                          width={`5vw`}
                                                        />
                                                      }
                                                    >
                                                      <button
                                                        className="size-[1.5vw] flex items-center justify-center rounded-[0.4vw] p-[0.5vw] hover:bg-slate-100"
                                                        type="button"
                                                        onClick={() =>
                                                          setShowEmojiPickerCaption(
                                                            !showEmojiPickerCaption
                                                          )
                                                        }
                                                      >
                                                        <img
                                                          src={
                                                            ICONS?.step3EmojiIcon
                                                          }
                                                          alt="emoji"
                                                          className="size-[1.5vw]"
                                                        />
                                                      </button>
                                                    </Popover>
                                                  </div>
                                                  <div className="pt-6">
                                                    {selectedFileType?.label ===
                                                      "IMAGE" &&
                                                      selectedFileURL && (
                                                        <img
                                                          src={selectedFileURL}
                                                          alt="preview images"
                                                          className="w-10 !h-10 rounded-md"
                                                        />
                                                      )}
                                                    {selectedFileType?.label ===
                                                      "VIDEO" &&
                                                      selectedFileURL && (
                                                        <div>
                                                          <video
                                                            className="w-10 !h-10 rounded-md"
                                                            controls
                                                          >
                                                            <source
                                                              src={
                                                                selectedFileURL
                                                              }
                                                              type="video/mp4"
                                                            />
                                                          </video>
                                                        </div>
                                                      )}
                                                    {selectedFileType?.label ===
                                                      "DOCUMENT" &&
                                                      selectedFileURL && (
                                                        <iframe
                                                          title="cover"
                                                          className="w-10 !h-10 rounded-md"
                                                          src={selectedFileURL}
                                                        ></iframe>
                                                      )}
                                                  </div>
                                                  {!isUploading && (
                                                    <div className="flex items-center justify-end mt-10">
                                                      <button
                                                        className={`  flex-row align-center rounded-[0.37vw] ${
                                                          !isMsgSending &&
                                                          allowToSendMessage()
                                                            ? "cursor-pointer bg-[var(--new-primary)] "
                                                            : "cursor-not-allowed bg-[var(--channelButton)] "
                                                        }`}
                                                        onClick={() => {
                                                          if (
                                                            !isMsgSending &&
                                                            allowToSendMessage()
                                                          ) {
                                                            sendMessage(
                                                              !activeTabItem?.send_from_phone_number_id
                                                                ? selectedPhoneNumber?.send_from_phone_number_id
                                                                : activeTabItem?.send_from_phone_number_id,
                                                              selectedPerson?.to_number,
                                                              currentBrand?.brand_id,
                                                              updatedData,
                                                              selectedPerson?.id
                                                            );
                                                          }
                                                        }}
                                                      >
                                                        {isMsgSending &&
                                                        selectedFileType ? (
                                                          <Loader
                                                            Width={20}
                                                            Height={20}
                                                            loaderBg="white"
                                                          />
                                                        ) : (
                                                          <div className="p-5 flex-row align-center">
                                                            <SendInbox
                                                              color={
                                                                allowToSendMessage()
                                                                  ? "white"
                                                                  : "var(--font-600)"
                                                              }
                                                              width={"1vw"}
                                                              height={"1vw"}
                                                            />
                                                          </div>
                                                        )}
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </Drawer>
                                          </div>
                                        )}

                                      {selectedFileType?.label === "DOCUMENT" &&
                                        selectedFileURL && (
                                          <div className={`${uploadContainer}`}>
                                            <DocSvg
                                              color="#fff"
                                              width={"1.5vw"}
                                              height={"1.5vw"}
                                            />
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                  {errorMsg && (
                                    <>
                                      {selectedFileType?.label === "IMAGE" &&
                                        errorMsg && (
                                          <div className={`${error}`}>
                                            Image size should be less than 5MB
                                          </div>
                                        )}

                                      {selectedFileType?.label === "VIDEO" &&
                                        errorMsg && (
                                          <div className={`${error}`}>
                                            Video size should be less than 16MB
                                          </div>
                                        )}

                                      {selectedFileType?.label === "DOCUMENT" &&
                                        errorMsg && (
                                          <div className={`${error}`}>
                                            Document size should be less than
                                            100MB
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )}
                      <div className="flex items-center justify-between rounded-b-[0.7vw]">
                        <div className="flex items-center gap-1">
                          <div className="w-auto flex items-center gap-[0.5vw] border-r-[0.08vw] border-[var(--border-50)] pr-[1vw]">
                            <button
                              className="flex items-center gap-[0.3vw] text-[rgba(135, 150, 175, 1)] var(--font-600) rounded-[0.3vw] p-1 hover:bg-[#ececeb] transition-colors duration-200"
                              onClick={handleChat}
                            >
                              <InboxNoteIcon />
                              <span className="text-[rgba(135,150,175,1)] font14px-400">
                                Note
                              </span>
                            </button>
                          </div>
                          {chatToggle && (
                            <div className="flex items-center">
                              <div className="w-auto h-fit flex items-center gap-[0.5vw]">
                                <button className="size-[1.5vw] hover:bg-slate-100 flex items-center justify-center rounded-[0.4vw] cursor-not-allowed">
                                  <img
                                    src={ICONS?.StarGroup}
                                    alt=""
                                    className="size-[0.8vw]"
                                  />
                                </button>
                                <button
                                  className="size-[1.5vw] hover:bg-slate-100 flex items-center justify-center rounded-[0.4vw]"
                                  onClick={() => {
                                    setOpenTemplateList(true);
                                  }}
                                >
                                  <img
                                    src={ICONS?.SelectTemplate}
                                    alt=""
                                    className="size-[0.9vw]"
                                  />
                                </button>
                              </div>
                              <div className="w-auto h-fit flex items-center gap-[0.5vw] border-x-[0.08vw] border-[var(--border-50)] px-[1vw] mx-[0.8vw]">
                                <InlineStyleControls
                                  options={INLINE_STYLES}
                                  editorState={editorState}
                                  onToggle={handleToolbarClick}
                                />
                              </div>
                              <div className="w-auto h-fit flex items-center gap-[0.5vw] border-r-[0.08vw] border-[var(--border-50)] pr-[1vw] relative">
                                {FEATURE_FLAG_SEND_ATTACHMENTS && (
                                  <Popover
                                    trigger={["click"]}
                                    open={openAttachment}
                                    onOpenChange={(open) => {
                                      setOpenAttachment(open);
                                    }}
                                    arrow={false}
                                    content={atteachmentsContent}
                                  >
                                    <button className="size-[1.5vw] hover:bg-slate-100 flex items-center justify-center rounded-[0.4vw]">
                                      <img
                                        src={ICONS?.Attachments}
                                        alt=""
                                        className="size-[1vw]"
                                      />
                                    </button>
                                  </Popover>
                                )}
                                <Popover
                                  trigger={["click"]}
                                  open={showEmojiPicker}
                                  onOpenChange={(open) =>
                                    setShowEmojiPicker(open)
                                  }
                                  arrow={false}
                                  content={
                                    <Picker
                                      data={data}
                                      onEmojiSelect={handleEmojiClick}
                                      searchPosition="none"
                                      previewPosition="none"
                                      width={`5vw`}
                                    />
                                  }
                                >
                                  <button
                                    className="size-[1.5vw] flex items-center justify-center rounded-[0.4vw] p-[0.5vw] hover:bg-slate-100"
                                    type="button"
                                    onClick={() =>
                                      setShowEmojiPicker(!showEmojiPicker)
                                    }
                                  >
                                    <img
                                      src={ICONS?.step3EmojiIcon}
                                      alt="emoji"
                                      className="size-[1vw]"
                                    />
                                  </button>
                                </Popover>
                              </div>
                              <div className="w-auto h-fit flex items-center gap-[0.5vw] border-[var(--border-50)] relative ml-1">
                                <Popover
                                  trigger={["click"]}
                                  open={showQuickRepliesManager}
                                  onOpenChange={(open) => {
                                    setShowQuickRepliesManager(open);
                                  }}
                                  arrow={false}
                                  content={
                                    <QuickReplyPanel
                                      quickReplies={quickReplies}
                                      setQuickReplies={setQuickReplies}
                                      loading={quickRepliesLoading}
                                      setLoading={setQuickRepliesLoading}
                                      setShowQuickRepliesManager={
                                        setShowQuickRepliesManager
                                      }
                                      currentBrand={currentBrand}
                                      selectedMessage={handleSelectedMessage}
                                    />
                                  }
                                >
                                  <button
                                    className={`p-[0.1vw] flex items-center cursor-pointer p-[5px] shrink-1 justify-center 
                                    rounded rounded-md text-gray-500  ${
                                      showQuickRepliesManager
                                        ? "bg-[rgba(231,224,253,1)] text-[rgba(105,64,242,1)]"
                                        : "hover:bg-slate-100"
                                    }
                                    transition-all duration-300`}
                                    onClick={() => {
                                      !showQuickRepliesManager &&
                                        fetchQuickReplies();
                                    }}
                                  >
                                    <LightningIcon svgClassName="size-[0.8vw]" />
                                  </button>
                                </Popover>
                              </div>
                            </div>
                          )}
                        </div>

                        {!isUploading && !selectedFileType && (
                          <div className="flex items-center">
                            <button
                              className={`  flex-row align-center rounded-[0.37vw] ${
                                !isMsgSending && allowToSendMessage()
                                  ? "cursor-pointer bg-[var(--new-primary)] "
                                  : "cursor-not-allowed bg-[var(--channelButton)] "
                              }`}
                              onClick={() => {
                                if (!isMsgSending && allowToSendMessage()) {
                                  sendMessage(
                                    !activeTabItem?.send_from_phone_number_id
                                      ? selectedPhoneNumber?.send_from_phone_number_id
                                      : activeTabItem?.send_from_phone_number_id,
                                    selectedPerson?.to_number,
                                    currentBrand?.brand_id,
                                    updatedData,
                                    selectedPerson?.id
                                  );
                                }
                              }}
                              disabled={item?.agent_engagement_status}
                            >
                              {isMsgSending && !selectedFileType ? (
                                <Loader
                                  Width={20}
                                  Height={20}
                                  loaderBg="white"
                                />
                              ) : (
                                <div className="pr-10 flex-row align-center">
                                  <span
                                    className={`px-2.5 py-1  ${
                                      allowToSendMessage()
                                        ? "text-[white]"
                                        : " text-[var(--font-600)]"
                                    }`}
                                  >
                                    Send
                                  </span>

                                  <SendInbox
                                    color={
                                      allowToSendMessage()
                                        ? "white"
                                        : "var(--font-600)"
                                    }
                                    width={"1vw"}
                                    height={"1vw"}
                                  />
                                </div>
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <NoteEditor
                      noteContent={noteContent}
                      setNoteContent={setNoteContent}
                      handleChat={handleChat}
                      showEmojiPickerCaption={showEmojiPickerCaption}
                      setShowEmojiPickerCaption={setShowEmojiPickerCaption}
                      data={data}
                      assignGetData={assignGetData}
                      textareaRef={textareaRef}
                      handleNoteEmojiClick={handleNoteEmojiClick}
                      noteUpdate={noteUpdate}
                      noteCreate={noteCreate}
                      isNoteLoading={isNoteLoading}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>

        {showList && (
          <Drawer
            placement="bottom"
            onClose={onCloseShowList}
            open={showList}
            closable={false}
            rootClassName="message-input-drawer w-full absolute !bottom-0 !left-[70%]"
            className="overflow-hidden !rounded-t-[80px]"
            onOpenChange={(open) => {
              onCloseShowList(open);
            }}
          >
            <div className="">
              <div
                className="w-1/5 bg-gray-400 h-2 contents-[''] rounded-full mx-auto mt-10 cursor-pointer"
                onClick={() => onCloseShowList()}
              ></div>
              {/* <div
              className='size-6 flex items-center justify-center p-1 cursor-pointer hover:bg-[var(--BG-50)] rounded-md'
              >
              <Xmark className='size-2.5' />
            </div> */}
              <div className="pt-8 flex flex-col gap-5">
                {selectedMessage?.data?.interactive?.action?.sections?.map(
                  (sec) => {
                    return (
                      <div className="py-2">
                        <h5 className="text-base weight-bold pb-2.5">
                          {sec?.title}
                        </h5>
                        <div className="flex flex-col px-5 gap-2.5">
                          {sec?.rows?.map((row) => {
                            return (
                              <div className="w-full h-7 flex items-center justify-between">
                                <p>{row.title}</p>
                                <p className="size-3.5 rounded-full border border-[var(--border-200)]"></p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </Drawer>
        )}

        <Modal
          open={openTemplateList}
          trigger={["click"]}
          afterOpenChange={(open) => {
            setOpenTemplateList(open);
          }}
          styles={{ content: { padding: 0 } }}
          centered
          footer={null}
          closable={false}
          mask={true}
          wrapClassName={"bg-[#00000095]"}
          onCancel={handleCancel}
          destroyOnClose
          width={"82vw"}
          style={{
            width: "100%",
            borderRadius: 20,
            boxShadow: "0px 10px 24px 0px rgba(79, 92, 128, 0.15)",
          }}
        >
          <Header
            title="Templates"
            titleSize="largest"
            rootStyle="!px-[1.5vw] !py-[1vw] gap-2"
            handleCancel={handleCancel}
            className="new-header"
            prefix={ICONS?.templateInoboxIcon}
          />

          <TemplateListContainer
            className="h-[58vh]"
            isSending={isSending}
            setIsSending={setIsSending}
            changeMedia={FEATURE_FLAG_TEMPLATE_CHANGE_MEDIA}
            changeVariable={FEATURE_FLAG_TEMPLATE_CHANGE_VARIABLE}
            sendTemplate={(data) => {
              const {
                bodyVariables,
                headerVariable,
                message_template_id,
                category,
                subcategory_type,
                payment_details,
                ...rest
              } = data;

              let variables = [
                ...new Set([...bodyVariables, ...headerVariable]),
              ];

              variables = Object.fromEntries(
                variables.map((item) => [
                  item?.title?.replace(/{{|}}/g, ""),
                  item?.value,
                ])
              );

              sendTemplate({
                sendFrom: !activeTabItem?.send_from_phone_number_id
                  ? selectedPhoneNumber?.send_from_phone_number_id
                  : activeTabItem?.send_from_phone_number_id,
                sendTo: selectedPerson?.to_number,
                metaTemplateId: message_template_id,
                brandId: currentBrand?.brand_id,
                subcategory_type: subcategory_type,
                category: category,
                mediaUrl: rest,
                variables: variables,
                payment_details: payment_details,
              });
            }}
          />
        </Modal>
      </>
    );
  }
);

export default MessageInput;
